module.exports = __webpack_public_path__ + "static/img/logo.2de0ce2e.jpg";